import React, { useState, useEffect, useRef, useContext } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { srBodyTemplate, CommonBodyForTable, commonFormDialogFooter, DateMonthBodyForTable } from "../Common/CommonComponents";
import ApiServices from "../../service/api/ApiServices";
import { Dialog } from "primereact/dialog";
import { CommonForDetails } from "../CRM/Leads";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { failureToast, successToast } from "../Common/CommonFunctions";
import { GSFCustomerOnboard } from "./GSFCustomerOnboard";
import { width } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import { permissionContext } from "../../AppWrapper";
const saved = localStorage.getItem("user");

// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class th   at handles API requests.
const apiServices = new ApiServices()

/** * EnquiryForm component to display a list of EnquiryForm in a data table.
 * It fetches the EnquiryForm data from the API and displays it in a paginated table format.
 * It also includes a search functionality to filter the EnquiryForm based on their names or other attributes.
 */
export const EnquiryForm = () => {

    const [customerList, setEnquiryFormList] = useState(null)
    const [loading, setLoading] = useState(false)
    const [globalFilter, setGlobalFilter] = useState('');
    const [enquiryDialog, setenquiryDialog] = useState(false);
    const [combosDialog, setCombosDialog] = useState(false);
    const [editedEnquiry, setEditedEnquiry] = useState(null);
    const [enquiryTemplate, setEnquiryTemplate] = useState({
        first_name: '',
        last_name: '',
        no_of_mch_required: '',
        location: '',
        mch_combo: [],
        pincode: '',
        phone_number: '',
    });
    const [comboTemplate, setComboTemplate] = useState({
        scheme: '',
        location: '',
        expected_cup_consumption: '',
        beverages: []
    });
    const [combosList, setCombosList] = useState([]);

    const [selectedScheme, setSelectedScheme] = useState('');
    const [selectedBeverage, setSelectedBeverage] = useState('');
    const [comboLocation, setComboLocation] = useState(null);
    const [expectedConsumption, setExpectedConsumption] = useState(null);
    const [beverageQuantity, setBeverageQuantity] = useState(null);
    const [addBeverageDialog, setAddBeverageDialog] = useState(false);
    const [beverageTemplateDetails, setBeverageTemplateDetails] = useState({
        name: '',
        quantity: ''
    });
    const [beveragesList, setBeveragesList] = useState([]);
    const [selectedBeverageItem, setSelectedBeverageItem] = useState(null);
    const [beveragesDropdownItems, setBeveragesDropdownItems] = useState({});
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [openOrderDialog, setOpenOrderDialog] = useState(false);
    const [preOrderData, setPreOrderData] = useState(null);
    const [deleteOrderId, setDeleteOrderId] = useState()
    const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)


    const schemesDropdownItems = {
        'Cherise Tapri Kettle': 'Cherise Tapri Kettle',
        'Cherise Tapri - Keypad': 'Cherise Tapri - Keypad',
        'Cherise Tapri - 10 inch Display': 'Cherise Tapri - 10 inch Display',
        'Cherise Tapri - 18 inch Display': 'Cherise Tapri - 18 inch Display'
    };

    const beverageDropdownOption = {
        "Mumbai Masala Chai": "Mumbai Masala Chai",
        "Madras Coffee": "Madras Coffee",
        "Calcutta Elaichi Chai": "Calcutta Elaichi Chai",
        "Delhi Adhrak Chai": "Delhi Adhrak Chai",
        "Gujarati Haldi Doodh": "Gujarati Haldi Doodh",
        "Hyderabadi Tomato Soup": "Hyderabadi Tomato Soup",
        "Colombiano Americano": "Colombiano Americano",
        "Milano Cappuccino": "Milano Cappuccino"
    };

    const kettleBeverageOptions = {
        "Mumbai Masala Chai": "Mumbai Masala Chai",
        "Calcutta Elaichi Chai": "Calcutta Elaichi Chai",
        "Delhi Adhrak Chai": "Delhi Adhrak Chai",
    }

    // Create a ref for the toast component to show notifications.
    const toast = useRef(null);
    const dataRef = useRef(null);

    const rolePermissions = useContext(permissionContext);

    useEffect(() => {
        getEnquiryForm()
        getCountry()
    }, [])

    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const exportCSV = () => {
        dataRef.current.exportCSV();
    }

    /** * Function to fetch countries from the API.
     * It updates the countries state variable with the fetched data.
     */
    const getCountry = async () => {
        const response = await apiServices.getCountry();
        setCountries(response?.data)
    }

    /** * Function to fetch states from the API based on the selected country.
     * It returns the list of states.
     * @param {Object} data - The data object containing the country ID.
     * @returns {Array} - The list of states.
     * */
    const getStates = async (data) => {
        const response = await apiServices.getState(data);
        return response?.data;
    }

    /** * Function to fetch cities based on the selected state.
     * It returns the list of cities.
     * @param {Object} data - The data object containing the state ID.
     * @returns {Array} - The list of cities.
     */
    const getCities = async (data) => {
        const response = await apiServices.getCity(data);
        return response?.data;
    }

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Enquiries</h6>
            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                    <Button className='custom-group-btn p-button-rounded p-m-2' onClick={() => { exportCSV(dataRef) }} icon="pi pi-download"></Button>
                </div>
            </span>
        </div>
    )

    /**
     * Function to fetch EnquiryForm data from the API
     * and update the state with the fetched data.
     */
    const getEnquiryForm = async (data = {}) => {
        setLoading(true)
        let response = await apiServices.getGSFEnquiryForm(data)
        response = response.data.response_obj;
        response = response.map((item, index) => {
            return {
                ...item,
                mch_combo_number: item.mch_combo ? item.mch_combo.length : 0, // Assuming mch_combo is an array
            }
        });
        if (response) {
            setEnquiryFormList(response)
        } else {
            setEnquiryFormList([])
        }
        setLoading(false)
    }

    const openDeleteDialog = async (data) => {
        setConfirmDeleteDialog(true)
        setDeleteOrderId(data.order_no);
    }

    const deleteDialogFooter = () => {
        return (
            <>
                <Button label="Yes, Delete it" icon='pi pi-check' className="p-button-success" onClick={() => { deletePreorder(deleteOrderId) }} />
                <Button label="Cancel" icon='pi pi-check' className="p-button-danger" onClick={() => { setConfirmDeleteDialog(false) }}></Button>
            </>
        )
    }

    const deletePreorder = async () => {
        setConfirmDeleteDialog(false);
        const response = await apiServices.gsfPreOrderDelete({ order_no: deleteOrderId })
        if (response?.data?.response_message === 'SUCCESS') {
            successToast(toast, "Preorder deleted successfully");
            getEnquiryForm();
        } else {
            failureToast(toast, "Failed to delete")
        }
    }

    /** * Function to render the action buttons for each row in the data table.
     * It includes Edit and View buttons with appropriate styles and actions.
     * @param {Object} rowData - The data of the current row.
     * @returns JSX element containing action buttons.
     */
    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Actions</span>
                <div className="actions" style={{ display: "flex" }}>
                    <Button icon='pi pi-trash' title='Delete PreOrder' className="p-button-rounded p-button-danger p-mx-2" aria-label="Delete PreOrder" onClick={() => { openDeleteDialog(rowData) }} />
                    {/* <Button icon="pi pi-eye" title='View Details' className="p-button-rounded p-button-info p-mx-2" aria-label="View Details" onClick={() => { openViewSalesMemberDialog(rowData) }} />
                    <Button icon="pi pi-pencil" title='Edit' className="p-button-rounded p-button-warning p-mx-1" aria-label="Edit" id={rowData.id} onClick={() => updateSalesMember(rowData)} /> */}
                </div>
            </>
        );
    }

    const openPlaceOrderDialog = (rowData) => {
        setPreOrderData(rowData)
        setOpenOrderDialog(true);
    }

    const actionBodyTemplateForOrder = (rowData) => {
        return (
            <>
                <span className="p-column-title">Place Order</span>
                <div className="actions" style={{ display: 'flex' }}></div>
                {
                    rowData.status === 'ORDER_PLACED' ? <Button label="Order Placed" className="p-button-secondary p-mr-2" disabled /> : (
                        rowData.operation_approval_status === "APPROVED" ?
                            <Button label="Place Order" className="p-button-success p-mr-2" onClick={() => { openPlaceOrderDialog(rowData) }} /> :
                            <Button label="Approval Pending" className="p-button-warning p-mr-2" disabled />
                    )
                }
            </>
        )
    }

    const openComboDetails = (_id) => {
        let data = customerList.find((item) => item._id === _id);
        console.log(data.mch_combo);
        setCombosList(data.mch_combo)
        setCombosDialog(true)
        // Fetch and set combo details based on _id if needed
    }

    /**
     * Function to render the machine combo number in the data table.
     * It displays the combo number as a clickable link that opens the combo details dialog.
     * @param {Object} rowData - The data of the current row.
     * @returns {JSX.Element} - The rendered combo number element.
     */
    const combosTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Actions</span>
                <div className="actions" style={{ display: "flex" }}>
                    <button onClick={() => { openComboDetails(rowData._id) }} style={{ cursor: "pointer", color: "blue", width: '100px' }}><u>{rowData.mch_combo_number}</u></button>
                </div>
            </>
        );
    }

    /**
     * Function to open the enquiry form dialog.
     * It resets the combosList state and sets the enquiryDialog state to true to show the dialog.
     */
    const openEnquiryForm = () => {
        setCombosList([])
        setenquiryDialog(true)
    }

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add Enquiry" icon="pi pi-user-edit" className="p-custom-btn p-ml-2" onClick={() => openEnquiryForm()} />
            </>
        )
    }

    /**
     * Function to handle changes in the enquiry inputs.
     * @param {*} e - The event object from the input change.
     * @returns {void}
     */
    const changeInputs = (e) => {
        // Update the enquiryTemplate state with the new input value
        setEnquiryTemplate({ ...enquiryTemplate, [e.target.name]: e.target.value })
    }

    /**
     * Function to handle changes in the combo inputs.
     * It updates the comboTemplate state with the new input value.
     * If the input is for 'scheme' or 'beverages', it updates the selectedScheme or selectedBeverage state accordingly.
     * @param {*} e - The event object from the input change.
     * @returns {void}
     */
    const changeInputsCombo = (e) => {
        // Update the enquiryTemplate state with the new input value
        if (e.target.name === 'scheme') {
            if (e.value.code == 'Cherise Tapri Kettle') {
                setBeveragesDropdownItems(kettleBeverageOptions);
            } else {
                setBeveragesDropdownItems(beverageDropdownOption);
            }
            setSelectedScheme(e.value);
            setComboTemplate({ ...comboTemplate, [e.target.name]: e.target.value.code })
            return;
        }


        if (e.target.name === 'beverages') {
            setSelectedBeverage(e.value);
            setComboTemplate({ ...comboTemplate, [e.target.name]: e.target.value.map(item => item.code) })
            return;
        }
        // Update the comboTemplate state with the new input value
        setComboTemplate({ ...comboTemplate, [e.target.name]: e.target.value })
    }

    /**
     * Function to handle changes in the beverage details inputs.
     * @param {*} e - The event object from the input change.
     * @returns {void}
     */
    const changeInputsBeverageDetails = (e) => {
        // Update the enquiryTemplate state with the new input value
        if (e.target.name === 'beverages') {
            // setSelectedBeverage(e.value);
            setSelectedBeverageItem(e.value);
            setBeverageTemplateDetails({ ...beverageTemplateDetails, name: e.target.value.code })
            return;
        }
        // Update the comboTemplate state with the new input value
        setBeverageTemplateDetails({ ...beverageTemplateDetails, [e.target.name]: e.target.value })
    }

    /**
     * Function to hide the enquiry dialog and reset the state variables.
     * It sets the enquiryTemplate to its initial values.
     * @returns {void}
     */
    const hideDialog = () => {
        setenquiryDialog(false)
        setEnquiryTemplate({
            customer_name: '',
            customer_contact: '',
            customer_email: '',
            location: '',
            expected_cup_consumption: '',
            beverages: []
        });
        setEditedEnquiry(null);
        setCombosList([]);
        setBeveragesList([]);
    }

    /**
     * Function to hide the combos dialog and reset the state variables.
     * It sets the combosList, selectedScheme, comboTemplate, and beveragesList to their initial values.
     * @returns {void}
     */
    const hideCombosDialog = () => {
        setCombosDialog(false)
        setCombosList([]);
        setSelectedScheme(null);
        setComboTemplate({
            scheme: '',
            location: '',
            expected_cup_consumption: '',
            beverages: []
        });
        setBeveragesList([]);

    }

    /**
     * Function to hide the add beverage dialog and reset the state variables.
     * It sets the selectedBeverageItem and beverageTemplateDetails to their initial values.
     */
    const hideAddBeverageDialog = () => {
        setAddBeverageDialog(false);
        // setBeveragesList([]);
        setSelectedBeverageItem(null);
        setBeverageTemplateDetails({
            name: '',
            quantity: ''
        });

    }

    const empDialogFooter = (
        <>
            <Button label="Close" icon="pi pi-times" className="p-button-danger p-mr-2 p-mb-2" onClick={hideDialog} />
            <Button label="Submit" type='submit' form='emp-form' icon="pi pi-check" className="p-button-success p-mr-2 p-mb-2" />
        </>
    );

    const combosDialogFooter = (
        <>
            <Button label="Close" icon="pi pi-times" className="p-button-danger p-mr-2 p-mb-2" onClick={hideCombosDialog} />
            <Button label="Submit" type='submit' form='combo-form' icon="pi pi-check" className="p-button-success p-mr-2 p-mb-2" />
        </>
    );

    const combosDetailsDialogFooter = (
        <>
            <Button label="Close" icon="pi pi-times" className="p-button-danger p-mr-2 p-mb-2" onClick={hideAddBeverageDialog} />
            <Button label="Submit" type='submit' form='combo-form' icon="pi pi-check" className="p-button-success p-mr-2 p-mb-2" />
        </>
    );

    /**
     * Function to render the machine scheme template.
     * @param {*} combo 
     * @returns 
     */
    const machineSchemeTemplate = (combo) => {
        return (
            <>
                {/* <div className='p-grid'> */}
                <div className="p-col-12">
                    <div className=" widget-performance">
                        <div className="content">
                            <ul style={{ backgroundColor: "#ede9e8", borderRadius: "10px", padding: "10px" }}>
                                <div className='p-grid'>
                                    <div className='p-col-3'><CommonForDetails name="Scheme" value={combo.scheme} /></div>
                                    <div className='p-col-3'><CommonForDetails name="Location" value={combo.location} /></div>
                                    <div className='p-col-3'><CommonForDetails name="Expected Cup Consumption" value={combo.expected_cup_consumption} /></div>
                                    {combo.beverages.map((beverage, index) => (
                                        <div className='p-col-3' key={index}><CommonForDetails name={`Beverage ${index + 1}`} value={`${beverage.name} - ${beverage.quantity}`} /></div>
                                    ))}
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </>
        );
    }

    /**
     * Function to render the beverage details in the machine scheme template.
     * It displays the name and quantity of the beverage in a structured format.
     * @param {*} beverage 
     * @returns 
     */
    const machineBeverageTemplate = (beverage) => {
        return (
            <>
                <div className='p-grid'>
                    <div className="p-col-12">
                        <div className=" widget-performance">
                            <div className="content">
                                <ul style={{ backgroundColor: "#ede9e8", borderRadius: "10px", padding: "10px" }}>
                                    <div className='p-grid'>
                                        <div className='p-col-6'><CommonForDetails name="Name" value={beverage.name} /></div>
                                        <div className='p-col-6'><CommonForDetails name="Quantity" value={beverage.quantity} /></div>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    /**
     * Function to handle the submission of the enquiry form.
     * It prevents the default form submission, constructs the enquiry data,
     * and sends it to the API using the createGSFEnquiryForm method.
     * @param {Object} e - The event object from the form submission.
     * @returns {Promise<void>} - A promise that resolves when the API call is complete.
 * */
    const onEmployeeSubmit = async (e) => {
        e.preventDefault();

        const data = { ...enquiryTemplate, mch_combo: combosList };
        console.log(data);
        const res = await apiServices.createGSFEnquiryForm(data);
        res?.data?.response_code ? successToast(toast, 'Employee Updated Successfully') : failureToast(toast, `Failed to Update, ${res?.data?.msg}`);
        // clearInputs()
        getEnquiryForm()
        setenquiryDialog(false)
        setEditedEnquiry(null);
        setCombosList([]);
        setBeveragesList([]);
        setSelectedScheme(null);
        setExpectedConsumption(null);

    }

    /** * Function to clear the input fields and reset the state variables.
     * It sets the selectedScheme, selectedBeverage, comboTemplate, comboLocation, expectedConsumption, and beverageTemplateDetails to their initial values.
     */
    const clearInputs = () => {
        setSelectedScheme(null);
        setSelectedBeverage(null);
        setComboTemplate({
            scheme: '',
            location: '',
            expected_cup_consumption: '',
            beverages: []
        });
        setComboLocation(null);
        setExpectedConsumption(null);
        setBeverageTemplateDetails({
            name: '',
            quantity: ''
        });
    }

    /**
     * 
     * @returns Function to add a new combo to the combosList state.
     * It checks if all required fields are filled, then adds the combo to the list.
     */
    const addCombo = () => {
        if (!comboTemplate.scheme || !comboTemplate.location || !comboTemplate.expected_cup_consumption || beveragesList.length === 0) {
            failureToast(toast, 'Please fill all the fields');
            return;
        }
        const updatedCombo = { ...comboTemplate, beverages: beveragesList };
        setComboTemplate(updatedCombo);
        let data = [...combosList, updatedCombo];
        setCombosList(data);
        setBeveragesList([]);
        clearInputs();
        console.log(combosList);
    }

    /**
     * 
     * @returns Function to add beverage details to the beveragesList state.
     * It checks if the name and quantity fields are filled, then adds the beverage details to the list.
     * @returns 
     */
    const addBeverageDetails = () => {
        if (!beverageTemplateDetails.name || !beverageTemplateDetails.quantity) {
            failureToast(toast, 'Please fill all the fields');
            return;
        }
        let data = [...beveragesList, beverageTemplateDetails];
        setBeveragesList(data);
        setSelectedBeverageItem(null);
        setBeverageQuantity(null);
        setBeverageTemplateDetails({
            name: '',
            quantity: ''
        });
        clearInputs();
        console.log(beveragesList);
    }

    const changePin = async (e) => {
        const pin = e.target.value.replace(/\D/g, ''); // only digits
        setEnquiryTemplate({ ...enquiryTemplate, [e.target.name]: pin });
        debugger
        if (pin.length === 6 && !isNaN(Number(pin))) {
            try {
                const response = await apiServices.getPincodeDetails(pin);

                if (response?.data[0]?.PostOffice?.length > 0) {
                    const postOffice = response.data[0].PostOffice[0];

                    const countryResult = postOffice.Country;
                    const stateResult = postOffice.State;
                    const cityResult = postOffice.District;
                    const blockResult = postOffice.Block;
                    const divisionResult = postOffice.Division;

                    // ✅ country
                    const defaultCountry = countries.find((x) => x.name === countryResult);
                    if (defaultCountry) {
                        setSelectedCountry(defaultCountry);

                        // ✅ states
                        const res = await apiServices.getState({ country_id: defaultCountry.id });
                        setSelectedState(res?.data);

                        const state = await getStates({ country_id: defaultCountry.id })
                        setStates(state)

                        const defaultState = res?.data?.find((x) => x.name === stateResult);
                        if (defaultState) {
                            setSelectedState(defaultState);

                            // ✅ cities
                            const res1 = await apiServices.getCity({ state_id: defaultState.id });
                            setCities(res1.data);

                            const defaultCity = res1?.data?.find(
                                (x) =>
                                    x.name === cityResult ||
                                    x.name === blockResult ||
                                    x.name === divisionResult
                            );
                            if (defaultCity) {
                                setSelectedCity(defaultCity);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching pincode details:", error);
            }
        }
    };

    const clearPreOrderData = () => {
        console.log('callback called')
        setPreOrderData(null)
    }

    return (

        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <Toast ref={toast} position="center" />
                    {
                        loading ?
                            <>
                                <div className="spinner-div">
                                    <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                </div>
                            </>
                            :
                            <>
                                <Toolbar className="p-mb-4 p-toolbar" right={rightToolbarTemplate}></Toolbar>
                                <DataTable style={tableStyle} className="datatable-responsive" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                    value={customerList} dataKey="id" exportFilename={`PreEnquiry Orders`}
                                    loading={loading} globalFilter={globalFilter} filterDisplay="menu" header={header} ref={dataRef}>
                                    <Column field="srid" header="Sr.No." body={srBodyTemplate} style={{ width: '1rem' }}></Column>
                                    {/* <Column field="first_name" header="First Name" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                    <Column field="last_name" header="Name" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column> */}
                                    <Column field="Full Name" header="Customer Name" body={(rowData) => `${rowData.first_name || ''} ${rowData.last_name || ''}`.trim()} style={{ width: '4rem' }} exportable={true}></Column>
                                    <Column field="phone_number" header="Contact" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                    <Column field="order_no" header="OrderId" sortable body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true} />
                                    <Column field="salesPerson_id" header="SalesPersonId" sortable body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true}></Column>
                                    <Column field="operation_approval_status" sortable header="Status" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                    <Column field="no_of_mch_required" header="Machines Required" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                    <Column field="location" header="Location" body={CommonBodyForTable} style={{ width: '5rem' }} exportable={true}></Column>
                                    <Column field="mch_combo_number" header="Machine Combos" body={combosTemplate} style={{ width: '3rem' }} exportable={true}></Column>
                                    <Column field="createdAt" header="Enquiry Date" body={DateMonthBodyForTable} sortable style={{ width: '3rem' }}></Column>
                                    <Column field="place_order" body={actionBodyTemplateForOrder} header="Place Order" style={{ width: '3rem' }}></Column>
                                    {rolePermissions?.deleteGsfCustomer && <Column field="action" body={actionBodyTemplate} header="Actions" style={{ width: '2rem' }}></Column>}
                                </DataTable>
                            </>
                    }

                    <Dialog visible={enquiryDialog} style={{ width: '650px' }} header={`${editedEnquiry ? 'Edit' : 'Add'} Enquiry Details`} modal className="p-fluid" footer={empDialogFooter} onHide={hideDialog} maximizable={true} blockScroll={true}>
                        <form onSubmit={onEmployeeSubmit} id="emp-form" className="p-fluid p-grid">

                            <div className="p-field p-col-6">
                                <label htmlFor="first_name">First Name</label>
                                <InputText id="first_name" name='first_name' placeholder='Enquiry Name' autoComplete="off" onChange={changeInputs} defaultValue={enquiryTemplate?.first_name} autoFocus required />
                            </div>
                            <div className="p-field p-col-6">
                                <label htmlFor="last_name">Last Name</label>
                                <InputText id="last_name" name='last_name' placeholder='Enquiry Name' autoComplete="off" onChange={changeInputs} defaultValue={enquiryTemplate?.last_name} autoFocus required />
                            </div>
                            <div className="p-field p-col-6">
                                <label htmlFor="phone_number">Contact</label>
                                <InputText id="phone_number" name='phone_number' minLength={10} maxLength={10} placeholder='Enquiry Contact' autoComplete="off" onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }} onChange={changeInputs} defaultValue={enquiryTemplate?.phone_number} required />
                            </div>
                            <div className="p-field p-col-6">
                                <label htmlFor="email">Email Id</label>
                                <InputText id="email" type="email" name="email" placeholder="Email Id" onChange={changeInputs} required />
                            </div>
                            <div className="p-field p-col-6">
                                <label htmlFor="no_of_mch_required">Number of Machines Required</label>
                                <InputText id="no_of_mch_required" type="number" min={0} name='no_of_mch_required' placeholder='Number of Machines Required' autoComplete="off" onChange={changeInputs} defaultValue={editedEnquiry?.numberOfMachinesRequired} required onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits allowed
                                }} />
                            </div>
                            <div className="p-field p-col-6">
                                <label htmlFor="pincode">Pincode</label>
                                <InputText
                                    id="pincode"
                                    maxLength={6}
                                    name="pincode"
                                    value={enquiryTemplate?.pincode || ""}
                                    onChange={changePin}
                                    placeholder="Pincode"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="p-col-12 p-md-6">
                                <label htmlFor="country1">Country</label>
                                <Dropdown id="country1" disabled name="country" value={selectedCountry} onChange={changeInputs} autoFocus required options={countries} optionLabel="name" placeholder="Select Country" filter className="multiselect-custom" />
                            </div>
                            <div className="p-col-12 p-md-6">
                                <label htmlFor="state1">State</label>
                                <Dropdown id="state1" disabled name="state" value={selectedState} onChange={changeInputs} autoFocus required options={states} optionLabel="name" placeholder="Select State" filter className="multiselect-custom" />
                            </div>
                            <div className="p-col-12 p-md-6">
                                <label htmlFor="city1">City</label>
                                <Dropdown id="city1" disabled name="city" value={selectedCity} onChange={changeInputs} autoFocus required options={cities} optionLabel="name" placeholder="Select City" filter className="multiselect-custom" />
                            </div>
                            <div className="p-fluid p-grid" style={{ backgroundColor: "#f5f5f5" }}>
                                <div className="p-col-12">
                                    <h5>Machine Combos</h5>
                                </div>
                                <div className="p-field p-col-6">
                                    <label htmlFor="scheme">Machine Scheme</label>
                                    <Dropdown id="scheme" name='scheme' options={Object.entries(schemesDropdownItems).map(([key, value]) => ({ name: value, code: key }))} onChange={changeInputsCombo} value={selectedScheme} optionLabel="name" placeholder="Select Card Type" disabled={editedEnquiry} required></Dropdown>
                                </div>
                                <div className="p-field p-col-6">
                                    <label htmlFor="location">Location</label>
                                    <InputText id="location" name='location' placeholder='Location' autoComplete="off" onChange={changeInputsCombo} defaultValue={comboLocation} required />
                                </div>
                                <div className="p-field p-col-6">
                                    <label htmlFor="expected_cup_consumption">Expected Cup Consumption</label>
                                    <InputText type="Number" id="expected_cup_consumption" min={0} name='expected_cup_consumption' placeholder='Expected Cup Consumption' autoComplete="off" onChange={changeInputsCombo} defaultValue={expectedConsumption} onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits allowed
                                    }} required />
                                </div>
                                <div className="p-field p-col-6">
                                    {/* <label htmlFor="beverages">Beverages</label>
                                    <MultiSelect id="beverages" name='beverages' options={Object.entries(BeveragesDropdownItems).map(([key, value]) => ({ name: value, code: key }))} onChange={changeInputsCombo} value={selectedBeverage} optionLabel="name" placeholder="Select Beverages" disabled={editedEnquiry}></MultiSelect> */}
                                </div>
                                {beveragesList.length > 0 && <div className='p-col-12'>
                                    <h6>Beverage Details</h6>
                                    {
                                        beveragesList.map((beverage, index) => (
                                            <React.Fragment key={index}>
                                                {machineBeverageTemplate(beverage)}
                                            </React.Fragment>
                                        ))
                                    }
                                </div>}
                                <div className="p-field p-col-6">
                                    <Button label="Add Beverage Details" type="button" icon="pi pi-plus" className="p-button-warning p-mr-2 p-mb-2" onClick={() => setAddBeverageDialog(true)} />
                                </div>
                                <div className="p-field p-col-6">
                                    <Button label="Add Combo" type="button" icon="pi pi-plus" className="p-button-danger p-mr-2 p-mb-2" onClick={() => addCombo()} />
                                </div>

                                {combosList.map((combo, index) => (
                                    <React.Fragment key={index}>
                                        {machineSchemeTemplate(combo)}
                                    </React.Fragment>
                                ))}
                            </div>


                        </form>
                    </Dialog>

                    <Dialog visible={combosDialog} style={{ width: '900px' }} header={`Machine Combos`} modal className="p-fluid" footer={combosDialogFooter} onHide={hideCombosDialog} maximizable={true} blockScroll={true}>
                        {combosList.map((combo, index) => (
                            <>
                                {machineSchemeTemplate(combo)}
                            </>
                        ))}
                    </Dialog>

                    <Dialog visible={confirmDeleteDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteDialogFooter} onHide={(e) => { setConfirmDeleteDialog(false) }}>
                        <div className="confirmation-content">
                            <center>
                                <i className="pi pi-exclamation-triangle p-error" style={{ fontSize: '4rem' }} /><br /><br />
                                <b><span>Are you sure you want to delete this preorder ?</span></b> <br /><br />                            </center>
                        </div>
                    </Dialog>

                    <Dialog visible={addBeverageDialog} style={{ width: '900px' }} header={`Beverage details`} modal className="p-fluid" footer={combosDetailsDialogFooter} onHide={hideAddBeverageDialog} maximizable={true} blockScroll={true}>
                        <div className="p-fluid p-grid" style={{ backgroundColor: "#f5f5f5" }}>
                            <div className="p-col-12">
                                <h5>Add Beverage Details</h5>
                            </div>
                            <div className="p-field p-col-6">
                                <label htmlFor="beverages">Beverages</label>
                                <Dropdown id="beverages" name='beverages' options={Object.entries(beveragesDropdownItems).map(([key, value]) => ({ name: value, code: key }))} onChange={changeInputsBeverageDetails} value={selectedBeverageItem} optionLabel="name" placeholder="Select Beverages" disabled={editedEnquiry}></Dropdown>
                            </div>
                            <div className="p-field p-col-6">
                                <label htmlFor="quantity">Quantity</label>
                                <InputText type="Number" min={0} id="quantity" name='quantity' placeholder='Quantity' autoComplete="off" onChange={changeInputsBeverageDetails} defaultValue={beverageQuantity} onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits allowed
                                }} />
                            </div>
                            <div className="p-field p-col-6">
                                <Button label="Add Beverage Details" type="button" icon="pi pi-plus" className="p-button-danger p-mr-2 p-mb-2" onClick={() => addBeverageDetails()} />
                            </div>
                            <div className='p-col-12'>
                                {beveragesList.map((beverage, index) => (
                                    <React.Fragment key={index}>
                                        {machineBeverageTemplate(beverage)}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </Dialog>

                    {/* <Dialog visible={openOrderDialog} style={{ width: '900px' }} header={`Place Onetime Order`} modal className="p-fluid" footer={combosDialogFooter} maximizable={true} blockScroll={true}> */}
                    {preOrderData && <GSFCustomerOnboard preOrderData={preOrderData} clearPreOrderData={clearPreOrderData} />}
                    {/* </Dialog> */}

                </div>
            </div>
        </>
    )
}